import { useState, useEffect } from 'react';
import { PropertyType, ActionsType } from '../../common';

interface StoreTypes {
	listenersType: React.Dispatch<React.SetStateAction<any>>[];
	dispatchType: (actionId: string, payload?: any) => void;
}

let globalState: PropertyType = {};
let listeners: StoreTypes['listenersType'] = [];
let actions: ActionsType = {};

export const useStore = (shouldListen = true): [PropertyType, StoreTypes['dispatchType']] => {
	const setState = useState(globalState)[1];

	const dispatch: StoreTypes['dispatchType'] = (actionId, payload) => {
		const sliceIdentifier = globalState?.slice ? `${globalState.slice}_${actionId}` : actionId;
		if (!actions[sliceIdentifier]) {
			return;
		}

		const result = actions[sliceIdentifier](globalState, payload);
		if (result && typeof (result as any).then === 'function') {
			(result as Promise<PropertyType>).then((newState) => {
				if (newState && actions[sliceIdentifier]) {
					globalState = { ...globalState, ...newState };
					for (const listener of listeners) {
						listener(globalState);
					}
				}
			});
		} else if (result) {
			globalState = { ...globalState, ...result };
			for (const listener of listeners) {
				listener(globalState);
			}
		}
	};

	useEffect(() => {
		if (shouldListen) {
			listeners.push(setState);
		}

		return () => {
			if (shouldListen) {
				listeners = listeners.filter((li) => li !== setState);
			}
		};
	}, [setState, shouldListen]);

	return [globalState, dispatch];
};

export const initStore = (userActions: ActionsType, initialState: PropertyType): void => {
	globalState = initialState ? { ...initialState } : {};
	let actionsByStoreSlice: PropertyType = {};

	if (initialState?.slice) {
		Object.keys(userActions).map((key) => {
			const identifier = `${initialState.slice}_${key}`;
			actionsByStoreSlice[identifier] = userActions[key];
		});
	} else {
		actionsByStoreSlice = { ...userActions };
	}
	actions = { ...actionsByStoreSlice };
};

export const resetStore = (): void => {
	globalState = {};
	actions = {};
};
